import { useMemo } from "react";
import { Link } from "react-router-dom";
import { CheckIcon, Pencil, Trash2, X } from "lucide-react";
// @ts-ignore
import moment from "moment-jalaali";
import { CellContext } from "@tanstack/react-table";

interface ColumnsProps {
  handleUpdateDataClick: (data: any) => void;
  onClickDelete: (data: any) => void;
  chengeStatus: (data: any) => void;
}

const createColumnUser = ({
  handleUpdateDataClick,
  onClickDelete,
  chengeStatus,
}: ColumnsProps) => {
  return [
    {
      header: "شناسه کاربر",
      accessorKey: "id",
      enableColumnFilter: false,
    },
    {
      header: "نام کاربری",
      accessorKey: "username",
      enableColumnFilter: true,
      cell: (cell: any) => (
        <Link
          to="#!"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "ایمیل",
      accessorKey: "email",
      enableColumnFilter: false,
    },
    {
      header: "نام کامل",
      accessorKey: "fullname",
      enableColumnFilter: false,
    },
    {
      header: "شماره تلفن",
      accessorKey: "phone_number",
      enableColumnFilter: false,
    },
    // {
    //   header: "وضعیت",
    //   accessorKey: "disabled",
    //   enableColumnFilter: false,
    //   cell: ({ row }: { row: { original: { disabled: boolean } } }) =>
    //     row.original.disabled ? "❌" : <CheckIcon className="text-green-600" />,
    // },
    {
      header: "وضعیت",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => {
        const status = cell.row.original.disabled;
        return (
          <div className="flex gap-3">
            <Link
              to="#!"
              data-modal-target="editUserModal"
              className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                chengeStatus(data);
              }}
            >
              {status ? (
                <X className="text-red-600 " size={20} />
              ) : (
                <CheckIcon size={20} />
              )}
            </Link>
          </div>
        );
      },
    },
    {
      header: "تاریخ ایجاد",
      accessorKey: "created_at",
      enableColumnFilter: false,
      cell: ({ getValue }: CellContext<any, string>) =>
        moment(getValue()).format("jYYYY/jMM/jDD"),
    },
    {
      header: "عملیات",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <div className="flex gap-3">
          <Link
            to="#!"
            data-modal-target="editUserModal"
            className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
            onClick={() => {
              const data = cell.row.original;
              handleUpdateDataClick(data);
            }}
          >
            <Pencil className="size-4" />
          </Link>
          <Link
            to="#!"
            className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
            onClick={() => {
              const data = cell.row.original;
              onClickDelete(data);
            }}
          >
            <Trash2 className="size-4" />
          </Link>
        </div>
      ),
    },
    // cell: ({ getValue }: CellContext<any, string>) =>
    //   moment(getValue()).format("jYYYY/jMM/jDD"),
    {
      header: "آخرین بروزرسانی",
      accessorKey: "updated_at",
      enableColumnFilter: false,
      cell: ({ getValue }: CellContext<any, string>) =>
        moment(getValue()).format("jYYYY/jMM/jDD"),
    },
  ];
};

export default createColumnUser;
